module.exports = __webpack_public_path__ + "img/bg-colors.1f3f0f43.svg";